<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items.sync="monthEndCloseList"
      item-key="_key"
      class="elevation-2 myDense"
      :rows-per-page-items="rowPerPage"
      >
      <template v-slot:items="props">
        <td>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span color="blue" v-on="on" small>{{props.item._key}}</span>
            </template>
            <span>{{ toTimestampString(props.item.createTime.toDate()) }}</span>
          </v-tooltip>
        </td>
        <td>
          {{formatInventoryData(props.item)}}
        </td>
        <td>
          {{formatBalanceData(props.item.balance)}}
        </td>
        <td text-xs-center>
          <v-layout justify-space-between>
            <v-flex>
              <v-btn dark color="primary" flat @click.stop="showMonthEndClosePopup(props.item)">
                  {{ $t('detail') }}
              </v-btn>
            </v-flex>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" flat dark color="primary">
                  {{ $t('more') }}<v-icon>expand_more</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="exportDataToExcel(props.item)">
                  <v-list-tile-title>{{ $t('export') }}</v-list-tile-title>
                </v-list-tile>
                <!-- <v-list-tile>
                  <v-list-tile-title>{{ $t('split') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title>{{ $t('close') }}</v-list-tile-title>
                </v-list-tile> -->
                <v-list-tile @click="deleteSingleMonthEndClose(props.item)">
                  <v-list-tile-title>
                      {{ $t('delete') }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-layout>
        </td>
        <SimpleTextPopup
          v-if="isShowMonthEndClosePopup"
          v-model="isShowMonthEndClosePopup"
          :title="$t('monthEndCloseDetail')"
          @popupClose="closeDetailPopup"
          hideRgtBtn
          medium
          >
            <template v-slot:input>
              <v-tabs
                v-model="activeTab"
                color="transparent"
                :label="activeTab"
                show-arrows
              >
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab
                  v-for="(tabItem) in tabs"
                  :key="tabItem"
                >
                  <span class="tabItem">
                    {{ tabItem }}
                  </span>
                </v-tab>
                <v-tab-item key="inventory">
                  <v-data-table
                    :headers="inventoryHeaders"
                    :items.sync="inventoryInShowList"
                    item-key="_key"
                    class="elevation-2 myDense"
                    :rows-per-page-items="rowPerPage"
                    >
                    <template v-slot:items="props">
                      <td>{{props.item[0] || ''}}</td>
                      <td>{{props.item[1].name || '---'}}</td>
                      <td>{{props.item[1].inStock || ''}}</td>
                      <td>{{props.item[1].shipments || ''}}</td>
                      <td>{{props.item[1].transferIn || ''}}</td>
                      <td>{{props.item[1].transferOut || ''}}</td>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item key="vendor">
                  <v-data-table
                    :headers="vendorHeaders"
                    :items.sync="vendorInShowList"
                    item-key="_key"
                    class="elevation-2 myDense"
                    :rows-per-page-items="rowPerPage"
                    >
                    <template v-slot:items="props">
                      <td>{{props.item[0]}}</td>
                      <td>{{props.item[1]}}</td>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item key="individual">
                  <v-data-table
                    :headers="individualHeaders"
                    :items.sync="membersInShowList"
                    item-key="_key"
                    class="elevation-2 myDense"
                    :rows-per-page-items="rowPerPage"
                    >
                    <template v-slot:items="props">
                      <td>{{props.item[0]}}</td>
                      <td>{{props.item[1] && props.item[1].pending}}</td>
                      <td>{{props.item[1] && props.item[1].released}}</td>
                      <td>{{props.item[1] && props.item[1].total}}</td>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </template>
          </SimpleTextPopup>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup.vue'
import PaginationController from './PaginationController.vue'
import {toTimestampString, toMoney} from '../utils/tools'
import xlsx from 'xlsx'
export default {
  name: 'MonthEndClose',
  data () {
    return {
      activeTab: 0,
      tabs: [
        this.$t('inventory'),
        this.$t('vendors'),
        this.$t('members')
      ],
      rowPerPage: [20, 50, {text: this.$t('all'), value: -1}],
      isShowMonthEndClosePopup: false,
      itemInShow: {},
      inventoryInShowList: [],
      vendorInShowList: [],
      membersInShowList: []
    }
  },
  components: {
    PaginationController,
    SimpleTextPopup
  },
  mounted () {
    this.getMonthEndCloseData()
  },
  computed: {
    headers () {
      return [
        { text: this.$t('createTime'), align: 'left', sortable: true, value: 'createTime', width: '10%' },
        { text: this.$t('inventoryInMonthEndClose'), align: 'left', sortable: false, value: '', width: '40%' },
        { text: this.$t('balanceInMonthEndClose'), value: 'serviceTypes', align: 'left', sortable: false, width: '40%' },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
    },
    inventoryHeaders () {
      return [
        { text: this.$t('upc'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('product'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('inStockQty'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('pendingShipmentQty'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('pendingTransferInQty'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('pendingTransferOutQty'), align: 'left', sortable: false, value: '', width: '10%' }
        // ,{ text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
    },
    vendorHeaders () {
      return [
        { text: this.$t('warehouse'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('balance'), align: 'left', sortable: false, value: '', width: '10%' }
        // ,{ text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
    },
    individualHeaders () {
      return [
        { text: this.$t('user'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('pending'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('released'), align: 'left', sortable: false, value: '', width: '10%' },
        { text: this.$t('totalInMonthEncClose'), align: 'left', sortable: false, value: '', width: '10%' }
        // ,{ text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
    },
    warehouses () { 
      return this.$store.getters.warehousesWithBalanceAndThreshold
    },
    users () {
      return this.$store.getters.userRequest.concat(this.$store.getters.users)
    },
    products () {
      return this.$store.getters.productsWithUpcChangeableFlag
    },
    monthEndCloseList () {
      return this.$store.getters.monthEndCloseData
    }
  },
  watch: {
    itemInShow (newValue, oldValue) {
      if (!Object.keys(newValue).length) return
      this.setNewInEditData(this.itemInShow)
    }
  },
  methods: {
    toTimestampString,
    showMonthEndClosePopup (item) {
      this.isShowMonthEndClosePopup = true
      this.itemInShow = item
    },
    async exportDataToExcel (item) {
      this.setNewInEditData(item)
      const name = item._key
      const newWorkBook = xlsx.utils.book_new()
      if (this.membersInShowList.length) {
        const membersSheetData = [['User', 'Pending', 'Released', 'Total']]
        this.membersInShowList.forEach(memberData => {
          membersSheetData.push([memberData[0], memberData[1].pending || '', memberData[1].released || '', memberData[1].total || ''])
        })
        const memberSheet = xlsx.utils.aoa_to_sheet(membersSheetData)
        xlsx.utils.book_append_sheet(newWorkBook, memberSheet, 'members')
      }
      if (this.vendorInShowList.length) {
        const vendorSheet = xlsx.utils.aoa_to_sheet([['Warehouse', 'Balance'], ...this.vendorInShowList])
        xlsx.utils.book_append_sheet(newWorkBook, vendorSheet, 'vendors')
      }
      if (this.inventoryInShowList.length) {
        const inventorySheetData = [['Upc', 'Product', 'InStock', 'Shipments', 'Transfer-in', 'Transfer-out']]
        this.inventoryInShowList.forEach(item => {
          inventorySheetData.push([item[0], item[1].name || '', item[1].inStock || '', item[1].shipments || '', item[1].transferIn || '', item[1].transferOut || ''])
        })
        const inventorySheet = xlsx.utils.aoa_to_sheet(inventorySheetData)
        xlsx.utils.book_append_sheet(newWorkBook, inventorySheet, 'inventory')
      }
      await xlsx.writeFile(newWorkBook, `${name}.xls`)
    },
    callMonthEndCloseRequest () {
      this.$store.dispatch('callMonthEndClose', {})
    },
    formatInventoryData (item) {
      const {inventoryInActiveShipment = {}, transferInInventory = {}, transferOutInventory = {}, inventoryInWarehouses = {}} = item
      const inventoryInActiveTransfer = Object.assign({}, transferInInventory, transferOutInventory)
      return `${(this.getSumValueFromData(inventoryInWarehouses) || 0)} --- ${(this.getSumValueFromData(inventoryInActiveShipment) || 0)} --- ${(this.getSumValueFromData(inventoryInActiveTransfer) || 0)}`
    },
    getSumValueFromData (dataObj, isBalance = false) {
      if (Array.isArray(dataObj) || isBalance) {
        return Object.values(dataObj).reduce((prev, cur) => toMoney(prev + (cur.quantity || cur.total || 0)), 0)
      } else {
        return Object.values(dataObj).reduce((prev, cur) => toMoney(prev + cur), 0)
      }
    },
    formatBalanceData (balanceObj) {
      const {systemBalance = 0, warehouseBalance = {}, individual = {}} = balanceObj
      return `${systemBalance.toLocaleString()} --- ${(this.getSumValueFromData(warehouseBalance) || 0).toLocaleString()} --- ${(this.getSumValueFromData(individual, true) || 0).toLocaleString()}`
    },
    calculateUpcSum (data = [], keywordsSort = [], sumObj = {}) {
      data.forEach((singleItem, index) => {
        const key = keywordsSort[index]
        if (Array.isArray(singleItem)) {
          return singleItem.forEach(item => {
            const matchedProduct = this.products.find(product => product.upc === item.upc) || {}
            if (sumObj[item.upc]) {
              if (sumObj[item.upc][key]) {
                sumObj[item.upc][key] += item.quantity || 0
              } else {
                sumObj[item.upc][key] = item.quantity || 0
              }
            } else {
              sumObj[item.upc] = {}
              sumObj[item.upc][key] = item.quantity || 0
              sumObj[item.upc]['name'] = matchedProduct.name
            }
          })
        } else {
          Object.keys(singleItem).forEach(upc => {
            const matchedProduct = this.products.find(product => product.upc === upc) || {}
            if (sumObj[upc]) {
              if (sumObj[upc][key]) {
                sumObj[upc][key] += singleItem[upc] || 0
              } else {
                sumObj[upc][key] = singleItem[upc] || 0
              }
            } else {
              sumObj[upc] = {}
              sumObj[upc][key] = singleItem[upc] || 0
              sumObj[upc]['name'] = matchedProduct.name
            }
          })
        }
      })
      return sumObj
    },
    closeDetailPopup () {
      this.isShowMonthEndClosePopup = false
      this.itemInShow = {}
    },
    getMonthEndCloseData () {
      this.$store.dispatch('getMonthEndCloseData')
    },
    async deleteSingleMonthEndClose (item) {
      if (confirm(this.$t('deleteConfirmation'))) {
        await this.$store.dispatch('deleteMonthEndCloseItem', item)
        // 将在store中的数据在前端过滤
        this.$store.dispatch('filterDeletedMonthEndCloseItem', item)
      }
    },
    setNewInEditData (itemInShow = {}) {
      const {inventoryInActiveShipment = {}, transferInInventory = {}, transferOutInventory = {}, inventoryInWarehouses = [], balance = {}} = itemInShow
      const upcSumObj = this.calculateUpcSum([inventoryInActiveShipment, transferInInventory, transferOutInventory, inventoryInWarehouses], ['shipments', 'transferIn', 'transferOut', 'inStock'])
      this.inventoryInShowList = Object.entries(upcSumObj)
      const {individual = {}, systemBalance = 0, warehouseBalance = {}} = balance
      const vendorInShowList = [['System', systemBalance.toLocaleString()]]
      Object.keys(warehouseBalance).forEach(warehouseKey => {
        const matchedItem = this.warehouses.find(warehouse => warehouse.warehouseKey === warehouseKey)
        vendorInShowList.push([matchedItem.warehouseName, (warehouseBalance[warehouseKey] || 0).toLocaleString()])
      })
      this.vendorInShowList = vendorInShowList
      const membersInShowList = []
      Object.keys(individual).forEach(userId => {
        const matchedUser = this.users.find(user => user.uid === userId)
        membersInShowList.push([matchedUser.name, individual[userId]])
      })
      this.membersInShowList = membersInShowList
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MonthEndClose.vue